<template>
  <div class="index">
    <div class="container">
      <topPart />
      <home-banner ref="homeBanner" :height="540"></home-banner>
      <router-view />
      <bottomPart />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import topPart from '@/components/topPart'
import bottomPart from '@/components/bottomPart'
  import homeBanner from "@/components/swiper.vue"
export default {
  name: 'Index',
  data() {
    return {}
  },
  components: {
    topPart,
    bottomPart,
    homeBanner
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}
#PageLeft .sort .navMainInner {
  cursor: pointer;
}
</style>
